<template>
  <div class="m-container py-8">
    <h1 class="text-h4 font-weight-bold mb-4">AGB</h1>
    <p class="text-body-1 text-grey-darken-1">Allgemeine Geschäftsbedingungen werden hier bald angezeigt.</p>
  </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: "AGB | Moebix",
  description:
    "Allgemeine Geschäftsbedingungen von Moebix.de — Möbel-Preisvergleich.",
  ogTitle: "AGB — Moebix.de",
  ogDescription:
    "Allgemeine Geschäftsbedingungen von Moebix.de — Möbel-Preisvergleich.",
  ogType: "website",
  ogImage: "/moebix_og_sticker.jpg",
  ogUrl: "https://www.moebix.de/agb",
});

useHead({
  link: [{ rel: "canonical", href: "https://www.moebix.de/agb" }],
});
</script>
